import React from 'react'

export default function NotFound () {
  return <h1> Unfortunately, this page is not available at this moment </h1>
}
